import { createSlice } from "@reduxjs/toolkit";

const initialStateValue = null;

export const deliveryDate = createSlice({
    name: "deliveryDate",
    initialState: {
        value: initialStateValue,
    },
    reducers: {
        setDeliveryDateReducer: (state, action) => {
            state.value = action.payload;
        },
        clearDeliveryDateReducer: (state) => {
            state.value = initialStateValue;
        },
    },
});
export const { setDeliveryDateReducer, clearDeliveryDateReducer } = deliveryDate.actions;
export default deliveryDate.reducer;
